import * as React from 'react';
import { useEffect, useRef, useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Container,
  Stack,
  Paper,
  Box,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Badge,
  Tooltip,
} from '@mui/material';
import { findCode, fullCopy, printVariable, download, hashids } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import { Grid } from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import { styled } from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { setSchola } from '@redux/actions/scholaAction';
import ConfirmDialog from "@components/ConfirmDialog";
import { useTheme } from '@mui/material/styles';
import { QuestionMarkTwoTone } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate, useLocation } from 'react-router-dom'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;

const PublicSurveyPartContent = () => {
  const { alert, renderAlert } = useAlert()
  const [notice, set_notice] = useState({})
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [record, set_record] = useState({})
  const [lecture, set_lecture] = useState({})
  const [student, set_student] = useState({})
  const [replCountMap, set_replCountMap] = useState({})
  const [allRepls, set_allRepls] = useState([])
  const [dirtyQuests, set_dirtyQuests] = useState({})
  const [saved, set_saved] = useState(null)
  const replsRef = useRef([])
  const dispatch = useDispatch()
  const theme = useTheme()
  const account = useSelector(state => state.accountReducer);
  const location = useLocation()
  const [pack, set_pack] = useState(location.state?.pack || null)
  // const pack  = location.state?.pack
  const navigate = useNavigate()
  const onLoad = async () => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const now = moment().format(dateFormat)
    const repls = []
    const record = pack?.data?.record
    const userId = pack?.data?.userId
    const lecture = pack?.data?.lecture
    const student = pack?.data?.student
    const replCountMap = pack?.data?.replCountMap
    const lectureId = lecture?.id ?? -1
    const studentId = student?.id ?? -1
    const school = record.school
    dispatch(setSchola(school))
    console.log('record=>', record)

    for (const quest of record.quests) {
      const repl = {
        id: -1,
        userId: userId,
        surveyId: quest.surveyId,
        questId: quest.id,
        lectureId: lectureId,
        studentId: studentId,
        ansIds: [],
        txt: '',
        regTime: now,
        uptTime: now,
        //
        sqNum: quest.sqNum,
        questCode: quest.questCode,
        mustYn: quest.mustYn,
      }
      repls.push(repl)
    }

    console.log(`repls=>`, repls)
    set_allRepls(repls)
    set_record(record)
    if (lecture?.id) {
      set_lecture(lecture)
    }
    if (student?.id) {
      set_student(student)
    }
    if (replCountMap) {
      const key = `${record.id}_${userId}_${lectureId}_${studentId}`
      console.log('key=>', key)
      const replCount = replCountMap[key] ?? 0
      if (replCount > 0) {
        set_saved(true)
      }
      else {
        set_saved(false)
      }
      set_replCountMap(replCountMap)

    }

    set_pack(location.state.pack)
  }

  const validate = () => {
    console.log(`allRepls`, allRepls)
    const repls = []
    let alarm = ''
    for (const repl of allRepls) {
      if (repl.mustYn == 'Y') {
        if (repl.questCode === 'Q000' || repl.questCode === 'Q001') {
          if (repl.ansIds.length == 0) {
            dirtyQuests[repl.questId] = '응답 필수입니다.'
            set_dirtyQuests({ ...dirtyQuests })

            alarm = `Q.${repl.sqNum} 응답 필수입니다.`
            alert(alarm)

            const element = document.getElementById(`quest-${repl.questId}`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return
          }
          else {
            for (const ansId of repl.ansIds) {
              const d = { ...repl, ansId: ansId }
              repls.push(d)
            }
          }
        }
        else {
          if (!repl.txt.trim()) {
            alarm = `Q.${repl.sqNum} 응답 필수입니다.`
            alert(alarm)
            dirtyQuests[repl.questId] = '응답 필수입니다.'
            set_dirtyQuests({ ...dirtyQuests })

            const element = document.getElementById(`quest-${repl.questId}`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return
          }
          else {
            const d = { ...repl, ansId: -1 }
            repls.push(d)
          }
        }
      }
      else {
        if (repl.questCode === 'Q000' || repl.questCode === 'Q001') {
          if (repl.ansIds.length > 0) {
            for (const ansId of repl.ansIds) {
              const d = { ...repl, ansId: ansId }
              repls.push(d)
            }
          }
        }
        else {
          if (repl.txt.trim()) {
            const d = { ...repl, ansId: -1 }
            repls.push(d)
          }
        }
      }
    }
    replsRef.current = repls
    console.log('repls=>', replsRef.current)
    return true
  }

  const onDeleteRepl = async () => {
    const encSurveyId = hashids.encode(pack?.data?.record?.id)
    const userToken = hashids.encode(pack?.data?.userId)
    const lectureId = pack?.data?.lecture?.id || -1
    const studentId = pack?.data?.student?.id || -1
    const url = `/public/survey/repl/${encSurveyId}/user/${userToken}/${lectureId}/${studentId}`
    const resp = await WebService.delete(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const replCountMap = JSON.parse(repMessage.replCountMap)
    set_replCountMap(replCountMap)
    alert('삭제되었습니다.', () => {
      set_saved(false)
      // window.location.reload()
    })

    // openSnackbar('삭제되었습니다.')
  }

  const onSubmit = async () => {
    if (replsRef.current.length == 0) {
      return
    }
    const surveyId = replsRef.current[0].surveyId

    const url = `/public/survey/repl/${surveyId}`
    console.log('replsRef.current=>', replsRef.current)
    const data = {
      surveyRepls: JSON.stringify(replsRef.current)
    }

    console.log('data=>', data)
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }

    set_saved(true)
    alert('설문제출이 완료되었습니다. 설문조사에 응해 주셔서 감사합니다.')


  }

  useEffect(() => {
    if (pack?.data?.record?.id) {
      onLoad()
    }
  }, [pack])

  if(record?.id && record.statCode !== 'R001') {
    return(
      <Container maxWidth='sm'>
        <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }} variant='h5'>
            {record?.title}
          </Typography>
          <Typography  textAlign={'center'}>
            해당 설문조사는 게시 중이 아닙니다.
          </Typography>
        </Grid>
        </Grid>
      </Container>
    )
    
  }

  return (
    <Container maxWidth='sm'

    >
      {renderIndicator()}
      {renderAlert()}
      <Grid container spacing={1}>
        {
          record?.modeCode === 'M001' ? (
            <Grid item xs={12}>
              <IconButton
                onClick={() => {
                  navigate(-1)
                }}
              >
                <ArrowBackOutlinedIcon />
              </IconButton>
            </Grid>
          ) : null
        }


        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold', textAlign: 'center' }} variant={'h5'}>{record?.title}</Typography>
          {
            saved && record?.statCode === 'R001' ? (
              <>
                <Typography style={{ fontWeight: 'bold', textAlign: 'center' }} variant={'body2'} color={theme.palette.secondary.main}>
                  이 설문조사에 제출이 완료되었습니다.
                </Typography>
                <ConfirmDialog
                  btn={
                    <Button variant='contained'
                      color='warning'
                      onMouseOver={() => {
                        document.activeElement?.blur();
                      }}
                    >
                      내 응답 삭제
                    </Button>
                  }
                  title={'설문 응답 삭제'}
                  content={'제출한 설문 응답을 삭제하시겠습니까?'}
                  bc={'warning'}
                  preHandle={async () => {
                    return true
                  }}
                  perform={() => {
                    onDeleteRepl()
                  }}
                />

              </>

            ) : null
          }
        </Grid>

        {
          record?.statCode === 'R001' ? (
            <>
              <Grid item xs={12}>
                <Typography variant='body2' sx={{ whiteSpace: 'pre-line', color: '#424242' }}>{record?.content} </Typography>
              </Grid>
              <Grid item xs={12}>
                {
                  student.id ? (
                    <Stack direction="row" spacing={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                        {student.name}
                      </Typography>
                      <Typography variant='body2'>
                        {student.grade}학년 {student.className}반 {student.classNum}번
                      </Typography>
                    </Stack>
                  ) : null
                }
              </Grid>
              <Grid item xs={12}>
                {
                  lecture.id ? (
                    <Stack direction="row" spacing={1} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography style={{ fontWeight: 'bold' }}>{lecture.title}</Typography>
                      <Typography variant='body2'>설문조사</Typography>
                    </Stack>

                  ) : null
                }
              </Grid>
              <Grid item xs={12}>
                {
                  record?.quests.map((quest, idx) => (
                    <Stack id={`quest-${quest.id}`} style={{ backgroundColor: '#eee', padding: 20, paddingTop: idx == 0 ? 20 : 0 }}>
                      <Paper elevation={1} style={{ backgroundColor: '#fff', padding: 10 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', }}>
                            <Typography key={idx} style={{ fontWeight: 'bold' }}>
                              Q {quest.sqNum}. {quest.txt}
                            </Typography>
                            {
                              (() => {
                                let expl = quest.mustYn === 'Y' ? '응답필수' : ''
                                expl += quest.questCode === 'Q001' ? ', 복수선택가능' : ''
                                if (expl) {
                                  return (
                                    <Typography variant='body2'>{`(${expl})`}</Typography>
                                  )
                                }

                              })()
                            }

                          </Grid>
                          <Grid item xs={12}>
                            <Grid container spacing={1}>
                              {
                                <Grid item xs={12}>
                                  {
                                    quest.questCode === 'Q000' ? (
                                      <FormControl>
                                        <RadioGroup
                                          aria-labelledby={`q_${idx}`}
                                          name={`q_${idx}`}
                                          onChange={e => {
                                            const found = allRepls.find(r => r.questId === quest.id)
                                            if (found) {
                                              found.ansIds = []
                                              found.ansIds.push(+e.target.value)
                                              dirtyQuests[quest.id] = ''
                                              set_dirtyQuests({ ...dirtyQuests })
                                            }
                                          }}
                                        >
                                          {
                                            quest.anss?.map((ans, idx2) => (
                                              <FormControlLabel key={ans.id} value={ans.id} control={<Radio />} label={ans.txt} />
                                            ))
                                          }
                                        </RadioGroup>
                                      </FormControl>
                                    ) : quest.questCode === 'Q001' ? (
                                      <FormControl>
                                        {
                                          quest.anss?.map((ans, idx2) => (
                                            <FormControlLabel
                                              key={ans.id}
                                              control={
                                                <Checkbox
                                                  color="primary"
                                                  name={ans.id}
                                                  value={ans.id}
                                                  onChange={e => {
                                                    const found = allRepls.find(r => r.questId === quest.id)
                                                    if (found) {
                                                      const ridx = found.ansIds.indexOf(+e.target.value)
                                                      if (e.target.checked) {
                                                        if (ridx < 0) {
                                                          found.ansIds.push(+e.target.value)
                                                        }
                                                      }
                                                      else {
                                                        if (ridx >= 0) {
                                                          found.ansIds.splice(ridx, 1)
                                                        }
                                                      }
                                                    }

                                                    if (found.ansIds.length == 0) {
                                                      if (quest.mustYn === 'Y') {
                                                        dirtyQuests[quest.id] = '응답 필수입니다.'
                                                      }
                                                    }
                                                    else {
                                                      dirtyQuests[quest.id] = ''
                                                    }
                                                    set_dirtyQuests({ ...dirtyQuests })
                                                  }}

                                                />
                                              }
                                              label={ans.txt}
                                            />
                                          ))
                                        }


                                      </FormControl>
                                    ) : (
                                      <TextField
                                        label={''}
                                        fullWidth
                                        multiline
                                        rows={4}
                                        name={'content'}
                                        onChange={e => {
                                          const found = allRepls.find(r => r.questId === quest.id)
                                          if (found) {
                                            found.txt = e.target.value
                                            if (found.txt.trim().length == 0) {
                                              dirtyQuests[quest.id] = '응답 필수입니다.'
                                            }
                                            else {
                                              dirtyQuests[quest.id] = ''
                                            }
                                            set_dirtyQuests({ ...dirtyQuests })
                                          }
                                        }}

                                      />
                                    )
                                  }

                                </Grid>
                              }
                            </Grid>
                            <FormHelperTexts>{dirtyQuests[quest.id]}</FormHelperTexts>
                          </Grid>
                        </Grid>
                      </Paper>

                    </Stack>
                  ))
                }
              </Grid>
              {
                saved !== null ? (
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', flex: 1, }}>
                    {/* <Button disabled={saved} style={{marginRight:10}}>다시 작성</Button> */}
                    <ConfirmDialog
                      btn={
                        <Button variant='contained'
                          disabled={saved}
                          onMouseOver={() => {
                            document.activeElement?.blur();
                          }}
                        >
                          설문제출
                        </Button>
                      }
                      title={'설문제출'}
                      content={'설문을 제출하시겠습니까?'}
                      bc={'primary'}
                      preHandle={async () => {
                        return validate()
                      }}
                      perform={() => {
                        onSubmit()
                      }}
                    />
                  </Grid>
                ) : null
              }
            </>
          ) : null
        }


      </Grid>

    </Container>
  )
}

export default PublicSurveyPartContent
